<template>
  <v-container class="pa-3" fluid>
    <v-card class="pa-6">
      <v-row>
        <v-col cols="12" md="6">
          <v-card-title class="text-h5">Report Detail Time Sheet</v-card-title>
        </v-col>
        <v-col align="right" color="primary" cols="12" md="6"> </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-autocomplete v-model="datasearch.employeename" :items="emp_list" item-text="name" item-value="id"
            label="Employee Name" clearable @click:clear="
              $nextTick(() => {
                datasearch.employeename = '';
              })
              " outlined dense></v-autocomplete>
          <!-- <v-text-field
            v-model="datasearch.employeename"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            outlined
            dense
          ></v-text-field> -->
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete v-model="datasearch.jobtitle_id" :items="jobtitle_list" item-text="name" item-value="id"
            label="Jobtitle / Case" clearable @click:clear="
              $nextTick(() => {
                datasearch.jobtitle_id = '';
              })
              " outlined dense></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete v-model="datasearch.chargetype" :items="charge_list" label="Charge Type" item-text="name"
            item-value="value" clearable @click:clear="
              $nextTick(() => {
                datasearch.chargetype = '';
                showchargetype = '';
              })
              " @change="findChaege(datasearch.chargetype)" outlined dense></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete v-model="datasearch.customername" :items="customer_list" item-text="name" item-value="name"
            label="Client Name" clearable @click:clear="
              $nextTick(() => {
                datasearch.customername = '';
              })
              " outlined dense></v-autocomplete>
        </v-col>
        <v-col cols="12" md="4">
          <v-autocomplete clearable @click:clear="
            $nextTick(() => {
              datasearch.department = 0;
            })
            " v-model="datasearch.department" :items="department_list" label="Department" item-text="department_name"
            item-value="id" outlined dense @change="OnSearchDepartment"></v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <v-menu v-model="menudatefrom" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateFromFormatted" label="DateFrom" append-icon="mdi-calendar" readonly
                dense outlined v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="datasearch.datefrom" @input="menudatefrom = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu v-model="menudateto" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="computedDateToFormatted" label="DateTo" append-icon="mdi-calendar" readonly dense
                outlined v-bind="attrs" v-on="on"></v-text-field>
            </template>
            <v-date-picker v-model="datasearch.dateto" @input="menudateto = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="mt-n12 ml-10" cols="12" md="2">
          <v-btn @click="SearchAlldata">
            <v-icon left>mdi-magnify</v-icon> Search</v-btn>
        </v-col>
      </v-row>

      <template>
        <div id="mydivhtmltobase">
          <div v-for="index in datashowAll.length" v-if="datashowAll.length >= 0 || pageAll >= 0">
            <div class="aligncenter" id="foo">
              <page size="A4" class="aligncenter">
                <div class="aligncenter">
                  <div class="rowprpo ">
                    <div class="col-md-6report"></div>
                    <div class="col-md-6report">
                      <p class="alignright  colprpo mr30prpo mt30">
                        Page : {{ index }}
                      </p>
                    </div>
                  </div>
                  <div class="rowprpo aligncenter" style="color:blue;">
                    <div class="col-md-12report mt-30prpo">
                      <h2>
                        {{ dataformatpr.title }}
                      </h2>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter" style="color:red;">
                    <div class="col-md-12report">
                      <h3>
                        {{ dataformatpr.subtitle }}
                      </h3>
                    </div>
                  </div>
                  <div class="rowprpo  aligncenter">
                    <div class="col-md-12report">
                      <h4 v-if="showchargetype != ''">
                        {{ dataformatpr.paymenttype }} :
                        {{ showchargetype }}
                      </h4>
                      <h4 v-else>
                        <br />
                      </h4>
                    </div>
                  </div>
                </div>

                <div class="rowprpo caption  ml30prpo mr30prpo" style="margin-top:10px">
                  <table class="captionhtable ">
                    <tr>
                      <th scope="colgroup" class="prbordertop2pxhtable prborderbottom2pxhtable width10">
                        <span class="alignleft">Client </span>
                      </th>
                      <th scope="colgroup" class="prbordertop2pxhtable prborderbottom2pxhtable width7">
                        <span class="alignleft">Case </span>
                      </th>
                      <th scope="colgroup" class="prbordertop2pxhtable prborderbottom2pxhtable width7">
                        <span class="alignleft">Date </span>
                      </th>
                      <th scope="colgroup" class="prbordertop2pxhtable prborderbottom2pxhtable width15">
                        <span class="alignleft">CheckIn-Out </span>
                      </th>
                      <th scope="colgroup" class="prbordertop2pxhtable prborderbottom2pxhtable width10">
                        <span class="alignleft">Lawyers </span>
                      </th>
                      <th scope="colgroup" class="prbordertop2pxhtable prborderbottom2pxhtable width10">
                        <span class="alignleft">Time </span>
                      </th>
                      <th scope="colgroup" class="prbordertop2pxhtable prborderbottom2pxhtable width40">
                        <span class="aligncenter">Details </span>
                      </th>
                    </tr>
                  </table>
                </div>

                <div v-for="(data, i) in datashowAll[index - 1]" id="content" class="">
                  <div class="rowprpo ml30prpo mr30prpo " v-if="i == 0 && data.no == 1">
                    <div class="width10 fixonerow">
                      <h4 class="alignleft ">
                        <span>{{ data.user_id }}</span>
                      </h4>
                    </div>
                    <div class="width90 fixonerow">
                      <h4 class="alignleft">
                        <span>
                          {{ data.fullname }}</span>
                      </h4>
                    </div>
                  </div>
                  <div class="rowprpo ml30prpo mr30prpo mt10 captionreport" v-if="data.changedepartment">
                    <div class="width10 fixonerow">
                      <h4 class="alignleft"></h4>
                    </div>
                    <div class="width15 textalignleft" colspan="2">
                      <span v-if="data.job_name"> <b>{{ data.job_name }}</b></span>
                      <span v-else> </span>
                    </div>
                    <div class="width15 textalignleft" colspan="2">
                      <span v-if="data.timecheckindate"><b>{{
                        data.timecheckindate
                          }}</b></span>
                      <span v-else></span>
                      &nbsp;
                      <span v-if="data.timecheckoutdate"><b>{{
                        data.timecheckoutdate
                          }}</b></span>
                      <span v-else></span>
                    </div>
                    <div class="width10 textalignleft"></div>
                    <div class="width10 textalignleft"></div>
                    <div class="width40 textalignleft" v-if="data.detail == ''">
                      <b v-if="data.absencestatus == ''">{{ data.absencestatus }}</b>
                      <b v-else>({{ data.absencestatus }})</b>
                    </div>
                    <div class="width40 textalignleft" v-else>
                      <b>({{ data.detail }} {{ data.absencestatus }})</b>
                    </div>
                  </div>

                  <div class="rowprpo ml30prpo mr30prpo captionreport" v-if="!data.changedepartment">
                    <div class="width10 textalignleft">
                      <!-- {{ data.no }} -->
                    </div>
                    <div class="width15 textalignleft" colspan="2">
                      {{ data.checkindate }}
                    </div>
                    <div class="width15 textalignleft" colspan="2">
                      <span v-if="data.timecheckindate">{{
                        data.timecheckindate
                      }}</span>
                      <span v-else>-</span>
                      &nbsp;
                      <span v-if="data.timecheckoutdate" style="padding-left: 2px;">{{
                        data.timecheckoutdate
                      }}</span>
                      <span v-else>-</span>
                    </div>

                    <!-- style="white-space: pre-line" -->
                    <div class="width10 textalignleft">
                      <span v-if="data.abbname_e_n">{{
                        data.abbname_e_n
                      }}</span>
                      <span v-else>-</span>
                    </div>
                    <div class="width10 textalignleft">
                      {{ data.duration }}
                    </div>
                    <div class="width40 textalignleft">
                      {{ data.detail }}
                    </div>
                  </div>
                  <div class="rowprpo ml30prpo mr30prpo mt-3" v-if="data.lastdata == 'lastindex'">
                    <div class="width10 fixonerow">
                      <h4 class="alignleft "></h4>
                    </div>
                    <div class="width30 fixonerow">
                      <h4 class="alignleft">
                        Total Time
                      </h4>
                    </div>
                    <div class="width60 fixonerow">
                      <h4 class="alignleft">
                        {{ data.totalclient }}
                      </h4>
                    </div>
                  </div>
                </div>
              </page>
            </div>
          </div>
        </div>
      </template>
      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-actions class="mt-5">
        <v-spacer></v-spacer>

        <v-btn v-if="this.datashowAll.length > 0" depressed outlined buttonred width="100" @click="exportToPDF">
          print
        </v-btn>

        <v-spacer></v-spacer>
      </v-card-actions>

      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

      <!-- <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" /> -->
    </v-card>
  </v-container>
</template>

<script>
import SuccessDialog from "@/components/cards/SuccessDialog";
import api from "@/services/api";
import { server } from "../services/constants";
import html2pdf from "html2pdf.js";
import unity from "@/unity/unity";

export default {
  async mounted() {
    // this.$showLoader();
    await api.checkVersion();
    this.mycompany_id = localStorage.getItem(server.COMPANYID);
    this.loadEmp();
    this.loadCustomer();
    this.loadJobtitle();
    await this.loadDepartmentByCompanyId();
    await this.loadCompany();
    setTimeout(() => {
      this.$hideLoader();
    }, 500);
  },
  components: {
    SuccessDialog,
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.datasearch.datefrom);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.datasearch.dateto);
    },
  },
  data() {
    return {
      isSearching: false,
      showchargetype: "",
      checkdepartmentname: "",
      lengthAlldatasearch: 0,
      menudateto: false,
      menudatefrom: false,
      mycompany_id: 0,
      datasearch: {
        employeename: "",
        customername: "",
        jobtitle_id: 0,
        chargetype: "",
        department: 0,
        // datefrom: "",
        // dateto: "",
        datefrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        dateto: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        // company_id: 13,
        company_id: localStorage.getItem(server.COMPANYID),
      },
      getnamesignature: [],
      prpoheader: [],
      memoref_list: [],
      no_list: [],
      mysignature: "",
      approvesignature: "",
      opensummarize: false,
      datashowAll: [],
      setdatatoshow: [],
      dataforshowprpo: [],
      getheightcontentpr: 0,
      pageAll: 1,
      previewattachimage: "",
      dataformatpr: {
        title: "",
        subtitle: "Time Sheet Monthly Report",
        paymenttype: "Payment Type",
        companyname_addressrow1:
          "เลขที่ 142 อาคาร ทู แปซิฟิค เพลส ชั้น20 ถนนสุขุมวิท แขวงคลองเตย",
        companyname_addressrow2: "เขตคลองเตย กรุงเทพฯ 10110",
        pr_number: "เลขที่ใบขอซื้อ/PR Number",
        pr_date: "วันที่/PR Date",
        companyname_tel: "โทรศัพท์/Tel. 02-6530489-9",
        companyname_fax: "โทรสาร/Fax. 02-6533706",
        prtitle_th: "ใบขอซื้อ",
        prtitle_en: "PURCHASE REQUISTION",
      },
      dataformatprdetail: {
        project: "โครงการ/Project",
        department: "แผนก/Department",
        requist_date: "วันที่ต้องการ/Requist date",
        type: "ประเภท/Type",
        date_period: "วันที่เริ่มต้น-สิ้นสุด/Date period",
        objective: "วัตถุประสงค์/PR Name",
        vender: "ชื่อผู้จำหน่าย/Vender",
      },
      department_list: [],
      charge_list: [
        { value: "T/C", name: "Time Charge" },
        { value: "N/C", name: "No Charge" },
        { value: "F/C", name: "Fix Charge" },
        { value: "OFF", name: "ทำงานออฟฟิต" },
      ],
      isShowPassword: false,
      fullPage: true,
      dialogEdit: false,
      dialogDelete: false,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      closeDelete: false,
      deleteItemConfirm: false,
      emp_list: [],
      jobtitle_list: [],
      customer_list: [],
    };
  },
  methods: {
    async loadEmp() {
      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID)
      );

      this.emp_list = result.data;
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.jobtitle_list = result.data;
    },
    async loadCustomer() {
      const result = await api.getAllCustomerListactiveCompany(
        {
          params: {
            company_id: localStorage.getItem(server.COMPANYID),
          },
        }
      );
      this.customer_list = result.data;
    },
    async loadCompany() {
      let copany_datat = await api.getCompanyByID(localStorage.getItem(server.COMPANYID));
      this.dataformatpr.title = copany_datat.data[0].name;
    },
    async loadDepartmentByCompanyId() {
      let result = await api.getNewAllDepartment_By_CompanyID(this.mycompany_id);
      this.department_list = result.data;
    },
    findChaege(chargetype) {
      this.charge_list.filter((item, index) => {

        if (item.value == chargetype) {
          this.showchargetype = item.name;
          return;
        }
      });
    },
    async OnSearchDepartment() {

    },
    async SearchAlldata() {
      if (this.isSearching) return;        // กันยิงซ้ำ
      this.isSearching = true;

      try {
        this.datashowAll = [];
        if (!this.datasearch.datefrom) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(true, "ค้นหาข้อมูล", "กรุณาเลือก DateFrom", "text-h5 red--text text-center");
          return;
        }
        if (!this.datasearch.dateto) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(true, "ค้นหาข้อมูล", "กรุณาเลือก DateTo", "text-h5 red--text text-center");
          return;
        }

        this.$showLoader();
        this.lengthAlldatasearch = 0;

        const result = await api.getfortimesheetAttendantreport({
          params: this.datasearch,
        });
        console.log("API length:", result.data?.length);

        if (!result.data || result.data.length === 0) {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(true, "ค้นหาข้อมูล", "ไม่มีข้อมูล", "text-h5 red--text text-center");
          return;
        }

        this.lengthAlldatasearch = result.data.length;

        // ✅ group ด้วย user_id (ไม่ใช่ user_name เพราะ null ทำให้กลุ่มเพี้ยน)
        const groups = new Map();
        for (const item of result.data) {
          const key = String(item.user_id);   // user_id เป็น key ที่ไม่ซ้ำและไม่เป็น null
          if (!groups.has(key)) {
            groups.set(key, []);
          }
          groups.get(key).push(item);
        }

        console.log("จำนวนกลุ่ม user:", groups.size, "(เรียก checkcontent", groups.size, "ครั้ง)");

        // ✅ วนทีละกลุ่ม ส่ง copy กัน reference ชน
        for (const [userId, dataList] of groups) {
          this.dataforshowprpo[0] = [...dataList];
          await this.checkcontent(this.dataforshowprpo[0]);
        }
      } catch (error) {
        console.error("SearchAlldata ERROR:", error);
      } finally {
        this.isSearching = false;
        this.$hideLoader();
      }
    },
    async checkcontent(data) {
      let totalclient = 0;
      this.setdatatoshow = [];
      let linedetailprpo = 37;
      let datainlineprpo = 55;
      let addnewbutget = 1;
      let getdata = [];
      let getnewdata = [];
      let hllinedetails = 0;
      this.pageAll = 1;
      let newhllinedetails = 0;

      for (let i = 0; i < this.dataforshowprpo[0].length; i++) {
        let stringchecklength = "";
        let lengthofdataforshowprpo = this.dataforshowprpo[0][i].detail.length;

        let maiek = "่"; //ไม้เอก
        let maito = "้"; //ไม้โท
        let maitree = "๊"; //ไม้ตรี
        let maijattawa = "๋"; //ไม้จัตวา
        let vowelei = "ิ"; //สระอิ
        let vowelee = "ี"; //สระอี
        let voweleue = "ึ"; //สระอึ
        let voweleu = "ื"; //สระอือ
        let vowelu = "ุ"; //สระอุ
        let voweluu = "ู"; //สระอู
        let maihun = "ั"; //ไม้หันอากาศ
        let maiyamok = "็"; //ไม้เอก
        newhllinedetails = 0;
        getnewdata = [];
        this.dataforshowprpo[0][i].no = i + 1;
        totalclient += parseFloat(
          this.dataforshowprpo[0][i].duration
            ? this.dataforshowprpo[0][i].duration
            : 0
        );
        if (i == 0) {
          this.checkdepartmentname = this.dataforshowprpo[0][i].job_name;
          this.dataforshowprpo[0][i].changedepartment = true;
        } else {
          if (
            this.checkdepartmentname !== this.dataforshowprpo[0][i].job_name
          ) {
            this.dataforshowprpo[0][i].changedepartment = true;
            this.checkdepartmentname = this.dataforshowprpo[0][i].job_name;
            hllinedetails++;
          }
        }
        stringchecklength = this.dataforshowprpo[0][i].detail;

        for (let j = 0; j < this.dataforshowprpo[0][i].detail.length; j++) {
          if (
            stringchecklength[j] == maiek ||
            stringchecklength[j] == maito ||
            stringchecklength[j] == maitree ||
            stringchecklength[j] == maijattawa ||
            stringchecklength[j] == vowelei ||
            stringchecklength[j] == vowelee ||
            stringchecklength[j] == voweleue ||
            stringchecklength[j] == voweleu ||
            stringchecklength[j] == vowelu ||
            stringchecklength[j] == voweluu ||
            stringchecklength[j] == maihun ||
            stringchecklength[j] == maiyamok
          ) {
            lengthofdataforshowprpo--;
          }
        }
        newhllinedetails = Math.ceil(lengthofdataforshowprpo / datainlineprpo);

        getnewdata.push(this.dataforshowprpo[0][i]);

        if (hllinedetails + newhllinedetails > linedetailprpo) {
          this.setdatatoshow[this.pageAll - 1] = getdata;
          this.pageAll++;

          hllinedetails = 0;
          getdata = [];
          getdata.push(this.dataforshowprpo[0][i]);
          hllinedetails += newhllinedetails;
          if (i == this.dataforshowprpo[0].length - 1) {
            this.dataforshowprpo[0][i].totalclient = totalclient.toFixed(2);
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        } else {
          hllinedetails += newhllinedetails;

          getdata.push(this.dataforshowprpo[0][i]);

          if (i == this.dataforshowprpo[0].length - 1) {
            this.dataforshowprpo[0][i].totalclient = totalclient.toFixed(2);
            this.setdatatoshow[this.pageAll - 1] = getdata;
            getdata = [];
          }
        }
      }

      this.pageAll += this.lengthAlldatasearch - 1;
      this.opensummarize = true;



      this.setdatatoshow.forEach((item, iitem) => {

        if (iitem == this.setdatatoshow.length - 1) {
          item[this.setdatatoshow[iitem].length - 1].lastdata = "lastindex";
        }

        this.datashowAll.push(item);
      });
    },

    async exportToPDF(advance_id) {
      // this.$refs.html2Pdf.generatePdf();
      let element = document.getElementById("mydivhtmltobase");

      const opt = {
        margin: [0, 0, 0, 0],
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        // enableLinks: false,
        html2canvas: {
          scale: 2,
          dpi: 192,
          letterRendering: true,
          useCORS: true,
          // ignoreElements: (e) => {
          //   return e.classList.contains("cke_pagebreak") ||
          //     e.classList.contains("html2pdf__page-break")
          //     ? true
          //     : false;
          // },
        },
        jsPDF: {
          unit: "cm",
          format: "A4",
          orientation: "portrait",
          putOnlyUsedFonts: true,
          pagesplit: true,
        },
        // pagebreak: { mode: ["avoid-all"], after: ".cke_pagebreak" },
      };

      let abcd = await html2pdf()
        .from(element)
        .set(opt)
        .toPdf()
        .get("pdf")
        // .output("bloburl")
        .then(function (pdf) {

          const totalPages = pdf.internal.getNumberOfPages();
          pdf.deletePage(totalPages);
          // var filtered = pdf.internal.pages.filter(function(el) {
          //   return el != null;
          // });

          // pdf.internal.pages = filtered;
          // for (let i = 0; i < totalPages; i++) {
          //   if (i == totalPages - 1) {
          //     pdf.internal.pages.splice(i, 1);
          //   }
          // }
          // pdf.addPage();


          return pdf.output("bloburl");
        });

      window.open(abcd);
      let blob = await fetch(abcd).then((r) => r.blob());

      // let formData = new FormData();
      // formData.append(`file`, blob, "test.pdf");
      // const resultadd = api.creatememoMaster(formData);


      // };
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
  },
  beforeCreate() {
    this.$store.state.navMenu = true;
  },
};
</script>

<style scoped>
body {
  background: rgb(204, 204, 204);
}

.page {
  background: white;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.5cm;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

.page[size="A4"][layout="landscape"] {
  width: 29.7cm;
  height: 21cm;
}

.page[size="A3"] {
  width: 29.7cm;
  height: 42cm;
}

.page[size="A3"][layout="landscape"] {
  width: 42cm;
  height: 29.7cm;
}

.page[size="A5"] {
  width: 14.8cm;
  height: 21cm;
}

.page[size="A5"][layout="landscape"] {
  width: 21cm;
  height: 14.8cm;
}

@page {
  size: 7in 9.25in;
  margin: 27mm 16mm 27mm 16mm;
}

page {
  position: relative;
  background: white;
  display: block;
  margin: 0 auto;
  /* margin-bottom: 0.5cm; */
  border: 1px solid;
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
}

page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}

page[size="A4"][layout="portrait"] {
  width: 29.7cm;
  height: 21cm;
}

@media print {

  body,
  page {
    margin: 0;
    box-shadow: 0;
  }

  html,
  body {
    width: 210mm;
    height: 297mm;
  }
}

.page {
  display: inline-block;
  position: relative;
  height: 297mm;
  width: 210mm;
  font-size: 12pt;
  margin: 2em auto;
  padding: calc(var(--bleeding) + var(--margin));
  /* box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5); */
  background: white;
}

@media screen {
  .page::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: calc(100% - var(--bleeding) * 2);
    height: calc(100% - var(--bleeding) * 2);
    margin: var(--bleeding);
    /* outline: thin dashed black; */
    pointer-events: none;
    z-index: 9999;
  }
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.btnuploadfile {
  border: 2px solid;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  width: 100%;
  background-color: #9e3b1b;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonwhite {
  width: 100%;
  background-color: #f5f5f5;
  color: black;
}

h3 {
  font-size: 1.17em;
}

h4 {
  font-size: 1em;
}

.test {
  border-style: double;
}

.borderblack {
  border-style: solid;
  border-width: thin;
}

.mt-50 {
  margin-top: 50px;
}

.mb-50 {
  margin-bottom: 50px;
}

.btn-light {
  color: #333;
  background-color: #fafafa;
  border-color: #ddd;
}

@media (min-width: 768px) {
  .wmin-md-400 {
    min-width: 400px !important;
  }
}

.btn-primary {
  color: #fff;
  background-color: #2196f3;
}

.btn-labeled>b {
  position: absolute;
  top: -1px;
  background-color: blue;
  display: block;
  line-height: 1;
  padding: 0.62503rem;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.aligncenter {
  text-align: center;
}

.captionreport {
  font-size: 0.85rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.captionhtable {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.0333333333em;
  line-height: 1.25rem;
  font-family: "Roboto", sans-serif;
}

.rowprpo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  margin-right: -12px;
  margin-left: -12px;
}

.colprpo {
  -ms-flex-preferred-size: 0;
  flex-basis: 0;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  max-width: 100%;
}

.col-md-1report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.333333333333333%;
  flex: 0 0 8.333333333333333%;
  max-width: 8.333333333333333%;
}

.col-md-2report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 16.66666666666667%;
  flex: 0 0 16.66666666666667%;
  max-width: 16.66666666666667%;
}

.col-md-3report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-4report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333333333333%;
  flex: 0 0 33.33333333333333%;
  max-width: 33.33333333333333%;
}

.col-md-5report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 41.66666666666667%;
  flex: 0 0 41.66666666666667%;
  max-width: 41.66666666666667%;
}

.col-md-6report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-7report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 58.33333333333333%;
  flex: 0 0 58.33333333333333%;
  max-width: 58.33333333333333%;
}

.col-md-8report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 66.66666666666667%;
  flex: 0 0 66.66666666666667%;
  max-width: 66.66666666666667%;
}

.col-md-9report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

.col-md-10report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 83.33333333333333%;
  flex: 0 0 83.33333333333333%;
  max-width: 83.33333333333333%;
}

.col-md-11report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 91.66666666666667%;
  flex: 0 0 91.66666666666667%;
  max-width: 91.66666666666667%;
}

.col-md-12report {
  word-wrap: break-word;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

.mt-30prpo {
  margin-top: -30px !important;
}

.mt30 {
  margin-top: 30px !important;
}

.mt10 {
  margin-top: 10px !important;
}

.mt25 {
  margin-top: 25px !important;
}

.mt-25prpo {
  margin-top: -25px !important;
}

.mr30prpo {
  margin-right: 30px !important;
}

.ml30prpo {
  margin-left: 30px !important;
}

.ml2prpo {
  margin-left: 2px !important;
}

.ml10prpo {
  margin-left: 10px !important;
}

.borderblockpr {
  border: 2px solid black;
  width: 100px;
  height: 150px;
  background: white;
  box-sizing: border-box;
  display: inline-block;
}

.col-md-4pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 30%;
  flex: 0 0 30%;
  max-width: 30%;
}

.col-md-8pr {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 70%;
  flex: 0 0 70%;
  max-width: 70%;
}

.col-md-4prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.col-md-8prrd {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

.textalignleft {
  text-align: left;
}

.textalignright {
  text-align: right;
}

table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  /* border: 1px solid black; */
}

.prbordertop {
  border-top: 1px solid black;
}

.prborderbottom {
  border-bottom: 1px solid black;
}

.prbordertop2pxhtable {
  padding-top: 8px;
  border-top: 2px solid black;
}

.prborderbottom2pxhtable {
  padding-bottom: 8px;
  border-bottom: 2px solid black;
}

td {
  /* border: 1px solid black; */
}

.width15 {
  word-wrap: break-word;
  width: 15%;
}

.width7 {
  word-wrap: break-word;
  width: 7%;
}

.width10 {
  word-wrap: break-word;
  width: 10%;
}

.width20 {
  word-wrap: break-word;
  width: 20%;
}

.width30 {
  word-wrap: break-word;
  width: 30%;
}

.width40 {
  word-wrap: break-word;
  width: 40%;
}

.width50 {
  word-wrap: break-word;
  width: 50%;
}

.width60 {
  word-wrap: break-word;
  width: 60%;
}

.width70 {
  word-wrap: break-word;
  width: 70%;
}

.width90 {
  word-wrap: break-word;
  width: 90%;
}

.width100 {
  word-wrap: break-word;
  width: 100%;
}

@media print {

  /*
          body.A3.landscape { width: 420mm }
          body.A3, body.A4.landscape { width: 297mm }
          body.A4, body.A5.landscape { width: 210mm }
          body.A5 { width: 148mm }*/
  .printonly {
    display: block;
  }

  .noprint {
    display: none;
  }

  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }
}

header {
  top: 0;
  padding-top: 150mm;
  padding-bottom: 3mm;
}

footer {
  bottom: 0;
  color: #000;
  padding-top: 3mm;
  padding-bottom: 5mm;
}

header,
footer {
  /* position: fixed; */
  left: 0;
  right: 0;
  background-color: #ccc;
  padding-right: 1.5cm;
  padding-left: 1.5cm;
}

.footerprpo {
  position: absolute;
  bottom: 10px;
  width: 90%;
}

.borderauto {
  border: 1px solid;
  margin: -1px;
}

.bordersignature {
  height: 110px;
  border: 1px solid;
  margin: -1px;
}

.fixtworow {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  overflow: hidden;
  text-align: left;
}

.fixonerow {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 20px;
  overflow: hidden;
  text-align: left;
}

.fontsize10 {
  font-size: 10px;
}
</style>
